import React, { useState, useEffect } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import validator from 'validator';

import documentTypes from '../../data/documentTypes';
import * as sinisterCardsActions from '../../redux/actions/sinister-cards';
import * as coveragesActions from '../../redux/actions/coverage';
import * as constants from '../../utils/constants';
import * as customRegex from '../../utils/validation/customRegex';
import * as http from '../../utils/http';
import {
  errorModalInfo,
  errorAlreadyRegisteredInfo,
  errorAlreadyRegisteredLetter,
  errorSinisterNotExits,
  errorOtherUserRegistered,
  errorSysDate,
  errorCaptcha,
  errorModStateAdvisor,
  errorModStateClient
} from '../../components/content/user-info/ModalInfo';
import {
  dynaTraceError,
  dynaTraceGetAction,
  dynaTraceLeaveAction,
  formatDate,
  checkIfHotjarEnable,
  timeBetweenDates,
} from '../../utils/helpers';
import history from '../../utils/history';
import { infoCardContents, departmentsTemp, requestConfig } from './data';
import SplitLayout from '../../layout/SplitLayout';
import Select from '../../components/common/select/Select';
import Input from '../../components/common/input/Input';
import Checkbox from '../../components/common/checkbox';
import InfoCard from '../../components/content/InfoCard/InfoCard';
import InputPicker from '../../components/common/inputpicker/InputPicker';
import Modal from '../../components/common/modal/Modal';
import InnerModal from '../../components/content/user-info/SubmitModal';
import Button from '../../components/common/button/Button';
import { coveragePlans } from '../../data/coveragePlan';
import IconWarning from '../../assets/icons/ic_warning_yellow.svg';
import Tooltip from '../../components/common/tooltip';
import IconInfo from '../../assets/icons/ic_info_blue.svg';


const API_URL = process.env.REACT_APP_API_UTI;

const UserInfoPage = () => {
  const dispatch = useDispatch();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const userInfo = useSelector((state) => state.sinisterCards.userInfo);
  const advisorInfo = useSelector( (state) => state.sinisterCards.advisorInfo)
  const savedDate = useSelector((state) => state.sinisterCards.sinisterDate);
  const registerNum = useSelector((state) => state.sinisterCards.sinisterNumberCase);
  const currentProduct = useSelector((state) => state.coverages.currentProduct);
  const coverageList = useSelector((state) => state.coverages.coveragesList);
  const userFlowType = useSelector((state) => state.coverages.userFlowType);
  const userPlanType = useSelector((state) => state.coverages.currentPlan);
  const onlyLettersAndSpacesRegex = new RegExp(
    customRegex.onlyLettersAndSpaces,
    'gm'
  );
  const phoneRegex = new RegExp(customRegex.onlyNumbers, 'gm');
  const documentTypeSelect = [...documentTypes];
  const [viewStartTime] = useState(new Date());
  const [isMessageVisible, setMessageVisible] = useState(false);
  const [departments, setDepartments] = useState(departmentsTemp);
  const [documentType, setDocumentType] = useState(documentTypeSelect[0]);
  const [documentNumber, setDocumentNumber] = useState(null);
  const [name, setName] = useState('');
  const [fatherLastName, setFatherLastName] = useState('');
  const [motherLastName, setMotherLastName] = useState('');
  const [department, setDepartment] = useState(null);
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [emailNotification, setEmailNotification] = useState(false);
  const [isTermsAccepted, setTerms] = useState(false);
  const [date, setDate] = useState(savedDate || null);

  const [docError, setDocError] = useState('');
  const [nameError, setNameError] = useState('');
  const [fatherLastError, setFatherLastError] = useState('');
  const [motherLastError, setMotherLastError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [dateError, setDateError] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [userError, setUserError] = useState(null);
  const [registerNumError, setRegisterNumError] = useState('');

  const [user, setUser] = useState(userInfo.name);
  const [userWait, setUserWait] = useState(false);
  const [infoType, setInfoType] = useState('info');
  const [updateCoverageList, setUpdateCoverageList] = useState(null);
  const [sysDate, setSysDate] = useState(null);

  const [tooltipActive, setTooltipActive] = useState(true);

  useEffect(() => { 
    setTimeout(() => {
      setTooltipActive(false);
    }, constants.DELAY_OUT_TOOLTIP);
  }, [])
  
  useEffect(() => {
    if (!API_URL) return;
    axios(requestConfig)
      .then(function (response) {
        const results = response.data.response.payload.map((item) => {
          return {
            text: item.descripcionDepartamento,
            value: item.codigoExternoDepartamento,
          };
        });
        setDepartments(results);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (!viewStartTime) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    const endTime = new Date();
    const userTotalTime = timeBetweenDates(viewStartTime, endTime);

    if (checkIfHotjarEnable()) {
      // LAST
      window.digitalData.push({
        task: {
          name: 'Tiempo registrado - Proteccion Tarjeta',
          time: userTotalTime,
        },
        event: 'trackTimeToComplete',
      });
    }
  }, [viewStartTime]);

  useEffect(() => {
    if (userFlowType === 'attach') {
      setInfoType('attach');
      setUser(true)
    }
    if (userInfo.name || (userFlowType === 'attach' && userInfo.document)) {
      setDocumentType(userInfo.documentType);
      setDocumentNumber(userInfo.document);
      setName(userInfo.name);
      setFatherLastName(userInfo.fatherLastName);
      setMotherLastName(userInfo.motherLastName);
      setDepartment(userInfo.department);
      setPhone(userInfo.phone);
      setEmail(userInfo.email);
      setEmailNotification(userInfo.emailNotification);
      setTerms(userInfo.terms);
    }

  }, [userInfo, userFlowType]);

  useEffect(() => {
    if (!userPlanType || userFlowType === 'attach') return;
    dispatch(coveragesActions.setInitCoverageList(userPlanType));
    setUpdateCoverageList(true);
  }, [dispatch, userPlanType, userFlowType]);

  useEffect( () => {
    if (!updateCoverageList) return;
    const  updateCoverage =  async () => {
    let productCoverages;
    const searchProductCoveragesString = `/coberturas?codigoProducto=${currentProduct}&plan=${userPlanType}`;
        productCoverages = await http.get(
          searchProductCoveragesString,
          {},
          'SALUD'
        );
      if (!productCoverages) {
        throw new Error('unknown error');
      }
      const updatedCoverageList = coverageList.map((coverage, i) => {
        const coverageFound = productCoverages.data.payload.coberturas?.find((cov) => {
          const diff1 = cov.codigoProducto === "1103" ? cov.orden : cov.id;
          const diff2 = cov.codigoProducto === "1103" ? coverage.sinisterNum : coverage.code;
          return diff1 === diff2;
        });
        const modalContent = coverageFound?.html.replace(/(<>|{' '})/g, '');
        if (coverageFound) {
          return {
            ...coverage,
            title: coverageFound.titulo,
            amountInfo:
              coverage.code === 'COB01'
                ? coverage.amountInfo
                : coverageFound.coberturaMaxima,
            description: coverageFound.descripcion,
            warningTxt: coverageFound.warningTxt,
            modalInfo:
              coverage.code === 'OTRO_SINIESTRO'
                ? coverage.modalInfo
                : modalContent,
            sinisterNumber: coverageFound.orden,
            userPlanType
          };
        }
        return coverage;
      });
      dispatch(coveragesActions.setCoverageList(updatedCoverageList));
      setUpdateCoverageList(false);
    }
    updateCoverage()
  }, [updateCoverageList]);

  const clearUserData = (emptyDocument = false) => {
    setUser(null);

    setName('');
    setFatherLastName('');
    setMotherLastName('');
    setDepartment('');
    setPhone('');
    setEmail('');
    setEmailNotification(false);
    const advisor = advisorInfo ? { ...advisorInfo } : undefined
    dispatch(sinisterCardsActions.resetState());
    dispatch(sinisterCardsActions.setAdvisorInfo(advisor));
    dispatch(coveragesActions.setUserFlowType('input'));
    setInfoType('info')

    if (emptyDocument) {
      setDocumentNumber('');
      setDocError('');
    }
  };

  const trackLogHotjar = (message) => {
    if (checkIfHotjarEnable()) {
      // LAST
     window.digitalData.push({
       log: {
         message: message,
       },
       event: 'trackLog',
     });
   }
  }

  const documentTypeHandler = (docData) => {
    setDocumentType(docData);
    clearUserData(true);
  };

  const inputDocumentHandler = (value) => {
    setDocumentNumber(value);
    clearUserData();
    setDocError('');

    if (value === '') {
      setDocError('*Por favor ingresa un número de documento válido');
      return;
    }

    switch (documentType.value) {
      case 'DNI':
        if (!validator.isNumeric(value)) {
          setDocError('*Por favor ingresa un número de documento válido');
        } else if (!validator.isLength(value, { min: 8, max: 8 })) {
          setDocError('*Se debe ingresar 8 números');
        }

        return;
      case 'PA':
        if (
          !validator.isAlphanumeric(value) ||
          !validator.isLength(value, { min: 5, max: 12 })
        ) {
          setDocError('*Por favor ingresa un número de documento válido');
        }

        return;
      case 'CE':
        if (
          !validator.isNumeric(value) ||
          !validator.isLength(value, { min: 9, max: 12 })
        ) {
          setDocError('*Por favor ingresa un número de documento válido');
        }

        return;
      default:
        return;
    }
  };

  const inputNameHandler = (value) => {
    if (onlyLettersAndSpacesRegex.test(value)
    && String(value).length >= 2 && String(value).length <= 40
    ) {
      setNameError('');
    } else {
      setNameError('*Por favor ingresa un nombre válido');
    }

    setName(value);
  };

  const inputFatherLastNameHandler = (value) => {
    if (onlyLettersAndSpacesRegex.test(String(value))
      && String(value).length >= 2 && String(value).length <= 40
    ) {
      setFatherLastError('');
    } else {
      setFatherLastError('*Por favor ingresa un Apellido válido');
    }

    setFatherLastName(value);
  };

  const inputMotherLastNameHandler = (value) => {
    if (onlyLettersAndSpacesRegex.test(String(value))
    && String(value).length >= 2 && String(value).length <= 40
    ) {
      setMotherLastError('');
    } else {
      setMotherLastError('*Por favor ingresa un Apellido válido');
    }

    setMotherLastName(value);
  };

  const selectDepartmentHandler = (data) => {
    setDepartment(data);
  };

  const inputPhoneHandler = (value) => {
    if (phoneRegex.test(value) && value.length >= 7) {
      setPhoneError('');
    } else {
      setPhoneError('*Por favor ingresar un Teléfono/Celular válido');
    }
    setPhone(value);
  };

  const inputEmailHandler = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/gm;
    const toIncludeRegex = /([^a-zA-Z0-9-_.])/gm;
    const lastCharacterRegex = /([a-zA-Z0-9])/gm;

    if (
      emailRegex.test(String(value).toLowerCase()) &&
      !toIncludeRegex.test(String(value.split('@')[0].toLowerCase())) &&
      !toIncludeRegex.test(String(value.split('@')[1].toLowerCase())) &&
      lastCharacterRegex.test(
        String(value).toLowerCase()[String(value).length - 1]
      )
    ) {
      setEmailError('');
    } else {
      setEmailError('*Por favor ingresar un correo electrónico válido');
    }

    setEmail(String(value).toLowerCase());
  };

  const inputRegisterNumHandler = (value) => {
    const firstTwoChar = value.substring(0, 2);
    const restChars = value.substring(2);
    if (
      value === '' ||
      firstTwoChar !== 'RG' ||
      isNaN(restChars) ||
      value.length < 10
    ) {
      setRegisterNumError('*Por favor, ingresa un número de registro válido como el ejemplo.');
    } else {
      setRegisterNumError('');
    }
    dispatch(sinisterCardsActions.setSinisterNumberCase(value));
  };

  const clickEmailNotificationHandler = () => {
    setEmailNotification(!emailNotification);
  };

  const validateUserExist = () => {
    const noErrors = !docError && !dateError;
    const noEmptyFields = documentType && documentNumber !== '' && date;

    return !(noEmptyFields && noErrors);
  };

  const validateFormHandler = () => {
    const noErrors =
      !docError &&
      !emailError &&
      !nameError &&
      !fatherLastError &&
      !motherLastError &&
      !phoneError;

    const noEmptyFields =
      documentType &&
      documentNumber !== '' &&
      name !== '' &&
      fatherLastName !== '' &&
      motherLastName !== '' &&
      department &&
      phone !== '' &&
      email !== '' &&
      emailNotification &&
      isTermsAccepted;

    // Si el plan ya tiene un caso abierto
    if (userFlowType === 'attach') {
      const noOpenCaseErrors = !registerNumError && registerNum !== '';
      const noOtherErrors = documentType && !docError && documentNumber !== '';
      return !(noOpenCaseErrors && noOtherErrors);
    }

    return !(noEmptyFields && noErrors);
  };

  const onDateChange = (e) => {
    setUser(null);
    setDate(e.value);
    if (userFlowType === 'attach') {
      clearUserData()
    }
    const currentDate = new Date(e.value);
    const year = currentDate.getFullYear();
    if (year < ((sysDate || (new Date())).getFullYear() - 10) && year !== 1969) {
      return setDateError(`*Por favor ingresa una fecha a partir del ${(sysDate || (new Date())).getFullYear() - 10}`);
    }
    if ((sysDate || (new Date())).getTime() < currentDate.getTime()) {
      return setDateError('*Fecha no puede ser mayor a hoy');
    }
    if (e.hasErrorFormat) {
      return setDateError('*Ingrese un fecha válida');
    }
    setDateError(false);
  };

  const onDateChangeBlur = () => {
    if (dateError) {
      trackLogHotjar(dateError);
    }
  }
  const onInputEmailBlur = () => {
    if (emailError) {
      trackLogHotjar(emailError);
    }
  }
  const onInputPhoneBlur = () => {
    if (phoneError) {
      trackLogHotjar(phoneError);
    }
  }
  const onInputRegisterNumBlur = () => {
    if (registerNumError) {
      trackLogHotjar(registerNumError);
    }
  }
  const onInputMotherLastNameBlur = () => {
    if (motherLastError) {
      trackLogHotjar(motherLastError);
    }
  }
  const onInputLastNameBlur = () => {
    if (fatherLastError) {
      trackLogHotjar(fatherLastError);
    }
  }
  const onInputNameBlur = () => {
    if (nameError) {
      trackLogHotjar(nameError);
    }
  }
  const onInputDocumentBlur = () => {
    if (docError) {
      trackLogHotjar(docError);
    }
  }

  const onUserSearchHandler = async () => {
    const action = dynaTraceGetAction('click search button');
    setUserWait(true);
    try {
      const token = await executeRecaptcha('login');
      const isTokenValid = await http.post('/captcha/random', { token });
      if (!isTokenValid || !isTokenValid.payload.status) {
        dynaTraceError('validation error', 'Captcha error');
        dynaTraceLeaveAction(action);
        setUserError(413);
        setModalOpen(true);
        return;
      }
      const payload = {
        tipoDocumento: documentType.value,
        nroDocumento: documentNumber,
        fechaSiniestro: formatDate(date),
      };
      const searchUserString = `/poliza?tipoDocumento=${payload.tipoDocumento}&nroDocumento=${payload.nroDocumento}&fechaSiniestro=${payload.fechaSiniestro}`;
       const isUserActive = await http.get(searchUserString, {}, 'SALUD');
      console.log('tamos por ac')
      if (isUserActive && isUserActive.data?.payload?.status) {
        const { producto, plan } = isUserActive.data.payload;
        const planType = plan?.split('_')[0];
        dispatch(coveragesActions.setProduct(producto));
        dispatch(coveragesActions.setCoveragePlanType(planType));
      }

      if (!isUserActive) {
        throw new Error('unknown error');
      }
      if (checkIfHotjarEnable()) {
        // LAST
        window.digitalData.push({
          "form": {
            "channel": "Protección Tarjeta BBVA",
            "name": "Formulario Datos Personales"
          },
          "event": "trackFormView"
        });
      }

      setModalOpen(false);
      setUser(isUserActive.data.payload);
      setInfoType('valid')
    } catch (err) {
      setUser(false);

      if (err?.response?.data?.error?.code === 'SINFORM002' && 
        err?.response?.data?.error?.details?.some(b => b.match('fechaSiniestro'))) {
        const { details } = err?.response?.data?.error || {};
        const sysDate = details?.find(b => b.match('fechaSiniestro')).split('|')[1].trim();
        if (sysDate) {
          const date = new Date(sysDate.split('/')[2], Number(sysDate.split('/')[1]) - 1, Number(sysDate.split('/')[0]));
          setSysDate(date);
          setUserError(412);
          setModalOpen(true);
          return;
        }
      }
      if (err?.response?.data?.error?.httpStatus === 404) {
        setUserError(404);
        setModalOpen(true);

        if (checkIfHotjarEnable()) {
          // LAST
          window.digitalData.push({
            log: {
              message: 'Póliza no encontrada',
            },
            event: 'trackLog',
          });
        }

        dynaTraceError('validation error', 'Poliza error');
      } else if (err?.response?.data?.error?.httpStatus === 429) {
        if (err.response.data.error.code === 'SINFORM014') {
          dispatch(coveragesActions.setUserFlowType('attach'));
          setInfoType('attach');
          setUser(true);
          if (checkIfHotjarEnable()) {
            // LAST
            window.digitalData.push({
              "log": {
                message: "El siniestro ya cuenta con un caso abierto"
              },
              event: "trackLog"
            });
          }
        } else if (err.response.data.error.code === 'SINFORM015') {
          setUserError(409);
          setModalOpen(true);
          if (checkIfHotjarEnable()) {
            // LAST
            window.digitalData.push({
              "virtual": {
                "name": `web:tramites-siniestros:proteccion-tarjeta-${userPlanType.toLowerCase()}:documentos-completados`
              },
              "event": "trackVirtual"
            });
          }
        } else if (err.response.data.error.code === 'SINFORM021') {
          if(advisorInfo) setUserError(431)
          else setUserError(430);
          setModalOpen(true);
          
          if (checkIfHotjarEnable()) {
            // LAST
            window.digitalData.push({
              "log": {
                message: "El siniestro se encuentra en estado MOD"
              },
              event: "trackLog"
            });
          }
        } else {
          setUserError(429);
          setModalOpen(true);
          if (checkIfHotjarEnable()) {
            // LAST
            window.digitalData.push({
              "virtual": {
                "name": `web:tramites-siniestros:proteccion-tarjeta-${userPlanType.toLowerCase()}:siniestro-registrado`
              },
              "event": "trackVirtual"
            });
          }
        }
      } else {
        dynaTraceError('server error', 'General Server error');
        history.push('/error');
      }
    } finally {
      setUserWait(false);
      dynaTraceLeaveAction(action);
    }

    dispatch(
      sinisterCardsActions.setSinisterDate({
        date,
      })
    );
  };

  const onContinueHandler = async () => {

    let planAttach;
    if (userFlowType === 'attach') {
      try {
        setUserWait(true);
        const {data} = await http.get(
          `/siniestros/${registerNum}?fechaSiniestro=${formatDate(date)}&tipoDocumento=${documentType.value}&numeroDocumento=${documentNumber}`,
          {},
          process.env.REACT_APP_API_NAME
        );
        const { plan } = data.payload;
        if (plan) {
          planAttach = plan?.split('_')[0];
          dispatch(coveragesActions.setCoveragePlanType(planAttach));
        }
      } catch (err) {
        console.log('error', JSON.stringify(err));
        if (err?.response?.data?.error?.code === 'SINFORM015') {
          setUserError(409);
          setModalOpen(true);
          clearUserData();
        } else if (err?.response?.data?.error?.code === 'SINFORM016') {
          setUserError(410);
          setModalOpen(true);
          if (checkIfHotjarEnable()) {
            // LAST
            window.digitalData.push({
              "error": {
                "code": "ErrorSiniestroTarjetaBBVA",
                "message": "El número de registro que registraste no corresponde a una solicitud"
              },
              "event": "trackError"
            });
          }
        } else if (err?.response?.data?.error?.code === 'SINFORM017') {
          setUserError(411);
          setModalOpen(true);
          if (checkIfHotjarEnable()) {
            // LAST
            window.digitalData.push({
              "error": {
                "code": "ErrorSiniestroTarjetaBBVA",
                "message": "El número de registro no está asociado al número de documento o fecha del siniestro"
              },
              "event": "trackError"
            });
          }
        } else {
          dynaTraceError('server error', 'General Server error');
          history.push('/error');
        }
        return;
      } finally {
        setUserWait(false);
      }
    }
    const action = dynaTraceGetAction('load detalle siniestro page');
    const formattedName = name
      .split(' ')
      .filter((el) => el !== '')
      .join(' ');
    const formattedFatherLastName = fatherLastName
      .split(' ')
      .filter((el) => el !== '')
      .join(' ');
    const formattedMotherLastName = motherLastName
      .split(' ')
      .filter((el) => el !== '')
      .join(' ');

    const userInfoObj = {
      documentType,
      document: documentNumber,
      name: formattedName,
      fatherLastName: formattedFatherLastName,
      motherLastName: formattedMotherLastName,
      department,
      phone,
      email,
      emailNotification,
      terms: isTermsAccepted,
    };

    dispatch(sinisterCardsActions.setUserInfo(userInfoObj));
    dispatch(sinisterCardsActions.incrementStep());
    dispatch(sinisterCardsActions.setSinisterDate({ date: date, time: '' }));

    dynaTraceLeaveAction(action);

    if (checkIfHotjarEnable()) {
      // LAST
      window.digitalData.push({
        "form": {
          "channel": "Protección Tarjeta BBVA",
          "name": "Formulario Datos Personales"
        },
        "event": "trackFormSubmit"
      });
    }

    if (userFlowType === 'input') {
      if (userPlanType === 'STANDAR') {
        history.replace(constants.PAGINAS_BY_STEP.DETALLE_SINIESTRO.uri);
        return;
      }
      history.replace(`/${coveragePlans[userPlanType].uri }${constants.PAGINAS_BY_STEP.DETALLE_SINIESTRO.uri}`);
    } else if (userFlowType === 'attach') {
        history.replace(`/${
          coveragePlans[planAttach].uri 
      }/documentos-requeridos`);
    } else {
      if (userPlanType === 'STANDAR') {
        history.replace('/resumen');
        return;
      }
      history.replace(`/${coveragePlans[userPlanType].uri}/resumen`);
    }
  };

  const leftContent = (
    <div className="titleCont">
      <h1 className="u-mb-24 heading-1">Seguro de Protección de Tarjetas</h1>
      <p>
        Hola, sabemos que sufriste un siniestro y queremos ayudarte a
        reportarlo.
      </p>
    </div>
  );

  const rightContent = (
    <>
      <div className="titleCont">
        <h3 className="u-mb-16">
          Ingresa tu información{' '}
          <Tooltip
            title="Importante"
            description={constants.TOOLTIP_MESSAGES.MSG_1}
            active={tooltipActive}
            hidden={!advisorInfo}
          >
            <img src={IconInfo} />
          </Tooltip>
        </h3>
        <p className="u-mb-16">
          Validaremos si tu póliza está vigente, ingresa la siguiente
          información:
        </p>
      </div>

      <div className="firstForm">
        <div className="firstForm__double">
          <div className="user-info__block--combo">
            <Select
              items={documentTypeSelect}
              selected={documentType}
              onClick={documentTypeHandler}
              label=""
              disabled={userFlowType === 'edit'}
            />
            <Input
              data-testid="document-input"
              type="text"
              label="Nº de documento"
              value={documentNumber}
              onChange={inputDocumentHandler}
              onBlur={onInputDocumentBlur}
              hasError={docError}
              errorClass="full-cont-grid"
              autoComplete="new-password"
              maxLength={12}
              disabled={userFlowType === 'edit'}
            />
          </div>
          <div className="firstForm__dateCont">
            <InputPicker
              label="Fecha del siniestro"
              maxDate={sysDate || new Date()}
              minDate={new Date((sysDate || new Date()).getFullYear() - 10, '00', '01')}
              onChange={onDateChange}
              onBlur={onDateChangeBlur}
              value={date}
              hasError={dateError}
              className="complaint__date-picker"
              untilToday
              disabled={userFlowType === 'edit'}
            />
          </div>
        </div>
      </div>

      <InfoCard
        icon={infoCardContents[infoType].icon}
        customClasses={'u-mb-40 u-mt-16'}
        content={infoCardContents[infoType].content}
      />

      {user && !docError && userFlowType === 'attach' && (
        <div className="registerForm">
          <h4 className="title u-mb-16">Ingresa el número de registro</h4>
          <p className="u-mb-8">
            Encuéntralo en el correo electrónico que te enviamos al registrar tu
            caso.
          </p>
          <Input
            type="text"
            label="Número de registro de siniestro"
            value={registerNum}
            onChange={inputRegisterNumHandler}
            onBlur={onInputRegisterNumBlur}
            hasError={registerNumError}
            autoComplete="new-password"
            className="first-input"
            maxLength={10}
            disabled={userFlowType === 'edit'}
          />
          <div className="amountWarning">
            <img
              className="amountWarning__img"
              src={IconWarning}
              alt="Ejemplo"
            /> {" "}
            Ejemplo: RG50495032
          </div>
        </div>
      )}

      <div>
        {user && !docError && userFlowType !== 'attach' && (
          <>
            <Input
              type="text"
              name='nombres'
              label="Nombres"
              value={name}
              onChange={inputNameHandler}
              onBlur={onInputNameBlur}
              hasError={nameError}
              autoComplete="new-password"
              className="first-input"
              maxLength={40}
              disabled={userFlowType === 'edit'}
            />
            <div className="user-info__block--divided">
              <div className="user-info__split-cont">
                <Input
                  type="text"
                  name='apellidoPaterno'
                  label="Apellido paterno"
                  value={fatherLastName}
                  onChange={inputFatherLastNameHandler}
                  onBlur={onInputLastNameBlur}
                  className="user-info__block--divided--first"
                  hasError={fatherLastError}
                  autoComplete="new-password"
                  maxLength={40}
                  disabled={userFlowType === 'edit'}
                />
              </div>
              <div className="user-info__split-cont">
                <Input
                  type="text"
                  name='apellidoMaterno'
                  label="Apellido materno"
                  value={motherLastName}
                  onChange={inputMotherLastNameHandler}
                  onBlur={onInputMotherLastNameBlur}
                  className="user-info__block--divided--second"
                  hasError={motherLastError}
                  autoComplete="new-password"
                  maxLength={40}
                  disabled={userFlowType === 'edit'}
                />
              </div>
            </div>
            <Select
              items={departments}
              selected={department}
              onClick={selectDepartmentHandler}
              label="Departamento donde vives"
              disabled={userFlowType === 'edit'}
            />
          </>
        )}
      </div>

      <div>
        {user && !docError && userFlowType !== 'attach' && (
          <>
            <h4 className="subtitle u-mb-16 u-mt-24">Medios de contacto</h4>
            <div className="user-info__block--divided">
              <div className="user-info__block--divided--first">
                <Input
                  type="number"
                  label="Teléfono/Celular"
                  value={phone}
                  maxLength={9}
                  onChange={inputPhoneHandler}
                  onBlur={onInputPhoneBlur}
                  hasError={phoneError}
                  autoComplete="new-password"
                />
              </div>
              <div className="user-info__block--divided--second">
                <Input
                  type="text"
                  label="Correo electrónico"
                  value={email}
                  onChange={inputEmailHandler}
                  onBlur={onInputEmailBlur}
                  hasError={emailError}
                  autoComplete="new-password"
                  maxLength={50}
                />
              </div>
            </div>
            <div className="user-info__block">
              <div className="user-info__block--checkbox">
                <Checkbox
                  label=""
                  checked={emailNotification}
                  onClick={clickEmailNotificationHandler}
                />
                <div className="user-info__block--checkbox-label">
                  <p>
                    Autorizo el envío de cualquier información, documento y/o notificación, relacionada a mi seguro, al correo electrónico o través de medios automatizados para efectos de la atención del siniestro.
                  </p>
                </div>
              </div>

              <div className="user-info__block--checkbox">
                <Checkbox
                  label=""
                  checked={isTermsAccepted}
                  onClick={() => setTerms(!isTermsAccepted)}
                />
                <div className="user-info__block--checkbox-label">
                  <p>
                    Acepto la política de{' '}
                    <a
                      className="linkGen"
                      href={constants.LINK_RIMAC_POLITICAS_DE_PRIVACIDAD}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      protección de datos personales.
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
  const renderSwitch = (errorCode, type) => {
    switch(errorCode) {
      case 429:
        return errorAlreadyRegisteredInfo[type];
      case 409:
        return errorAlreadyRegisteredLetter[type];
      case 410:
        return errorSinisterNotExits[type];
      case 411:
        return errorOtherUserRegistered[type];
      case 412:
        return errorSysDate[type];
      case 413:
        return errorCaptcha[type];
      case 430:
        return errorModStateClient[type];
      case 431:
        return errorModStateAdvisor[type];
      default:
        return errorModalInfo[type];
    }
  }
  return (
    <SplitLayout
      containerClasses="userInfoPage"
      leftClasses="userInfoPage__left"
      rightClasses="userInfoPage__right"
      leftContent={leftContent}
      rightContent={rightContent}
      onNavContinueClick={!user ? onUserSearchHandler : onContinueHandler}
      navCurrentStep={0}
      navTotalSteps={5}
      isNavActive={false}
      isNavNextDisabled={!user ? validateUserExist() : validateFormHandler()}
      navBtnText={!user ? 'Buscar' : 'Continuar'}
      isNavLoading={userWait}
    >
      <InnerModal
        icon={
          renderSwitch(userError, 'icon')
        }
        text={
          renderSwitch(userError, 'text')
        }
        title={
          renderSwitch(userError, 'title')
        }
        btnText={
          renderSwitch(userError, 'btnText')
        }
        open={isModalOpen}
        handleModal={setModalOpen}
        validated={false}
        userInfoObj={{}}
        width={userError === 404 ? '884px' : '544px'}
      />

      <div data-testid="userinfo-msg-modal" className="sinisterModal">
        <Modal
          onLabelClosed={true}
          visible={isMessageVisible}
          onToggle={() => setMessageVisible(false)}
          className={isMessageVisible ? 'sinisterModalMain--msg' : ''}
          onLabelTextClosed=""
        >
          <div className="innerModal">
            <h3>¿Ya seleccionaste todo?</h3>
            <p>
              Si necesitas reportar otra cobertura que no incluiste, escribe al
              correo: <br></br>
              <b>siniestrosprotecciondetarjeta@bbva.com</b> con el siguiente
              asunto: Nombres completos, DNI y fecha de siniestro. Detalla en el
              correo la cobertura solicitada y adjunta tus movimientos
              bancarios.
            </p>
            <Button primary onClick={() => () => setMessageVisible(false)}>
              Entendido
            </Button>
          </div>
        </Modal>
      </div>
    </SplitLayout>
  );
};

export default UserInfoPage;
